import React from 'react';
import styled from '@emotion/native';
import { StylingPreference } from '@/shared/types/stylist';
import useExploreStore from '@/stores/useExploreStore';
import PreferenceButton from '@/shared/components/PreferenceButton';
import { Title } from './styledComponents';

const StylingPreferencesFilter: React.FC = () => {
  const { filters, setFilters } = useExploreStore();

  function handlePreferenceChange(preference: StylingPreference) {
    setFilters({
      stylingPreferences: filters.stylingPreferences.includes(preference)
        ? filters.stylingPreferences.filter((p) => p !== preference)
        : [...filters.stylingPreferences, preference],
    });
  }

  function handleShowAll() {
    setFilters({ stylingPreferences: [] });
  }

  return (
    <Container>
      <Title>Filter by Style:</Title>
      <ButtonContainer>
        <PreferenceButton
          item="SHOW ALL"
          isSelected={filters.stylingPreferences.length === 0}
          isDesktop={false}
          onToggle={handleShowAll}
          buttonStyle={{ marginBottom: 0 }}
          textStyle={{ fontSize: 12 }}
        />
        {Object.values(StylingPreference).map((preference) => (
          <PreferenceButton
            key={preference}
            item={preference}
            isSelected={filters.stylingPreferences.includes(preference)}
            isDesktop={false}
            onToggle={() => handlePreferenceChange(preference)}
            buttonStyle={{
              width: '48%',
              height: 62,
              marginBottom: 0,
              paddingHorizontal: 22,
            }}
            textStyle={{ fontSize: 12 }}
          />
        ))}
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.View({
  marginBottom: 32,
});

const ButtonContainer = styled.View({
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: 8,
});

export default StylingPreferencesFilter;
